import { API } from '@Providers';

interface Payload {
  animal_ids: string[];
}

export default async function (payload: Payload) {
  const endpoint = '/api/shelter/voucher/get-outcome-voucher-options';

  return API({ endpoint, method: 'post', payload });
}
